<template>
	<Tabs v-model:value="selectedMainTabIndex" class="max-w-full min-w-0">
		<TabList>
			<Tab v-for="(tab, index) in tabs" :value="index" @click="changeTab(index)">
				<FontAwesomeIcon :icon="tab.icon === 'lightbulb-on' ? ['fas', tab.icon] : ['far', tab.icon]" class="mr-2" />
				{{ tab.tabName }}
			</Tab>
		</TabList>
		<TabPanels class="max-w-full min-w-0">
			<TabPanel v-for="(tab, index) in tabs" :value="index" class="max-w-full min-w-0">
				<commonTabs
					:tabName="tab.tabName"
					:assessmentId="assessmentId"
					:tabs="tab.tabs"
					:tabId="tab.id"
					:fullTabs="tabs"
					:selectedMainTabIndex="selectedMainTabIndex"
					:activeTab="tab.activeTab"
					@updateAllTabsInformation="updateAllTabsInformation"
					@updateAllTabsInformationPerMainTab="updateAllTabsInformationPerMainTab"
					:allTabsInformation="allTabsInformation"
				></commonTabs> </TabPanel
		></TabPanels>
	</Tabs>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from "vue"
import { useRouter, useRoute } from "vue-router"
import { EventBus } from "../eventBus"

import Tabs from "primevue/tabs"
import TabList from "primevue/tablist"
import Tab from "primevue/tab"
import TabPanels from "primevue/tabpanels"
import TabPanel from "primevue/tabpanel"
import commonTabs from "./commonTabs.vue"

//all the tabs
import assessmentTabempty from "./assessmentTabempty.vue"

import assessmentTabAssessmentName from "./assessmentTabAssessmentNamev1.vue"
import assessmentTabGeneralInformation from "./assessmentTabGeneralInformationv1.vue"
import assessmentTabRawMaterials from "./assessmentTabRawMaterialsv2.vue"
import assessmentTabUtilities from "./assessmentTabUtilitiesv1.vue"
import assessmentTabDownstreamDistribution from "./assessmentTabDownstreamDistributionv1.vue"
import assessmentTabResult from "./assessmentTabResult.vue"
import assessmentTabBiologicsResult from "./assessmentTabBiologicsResult.vue"
import assessmentTabProductProcessResult from "./assessmentTabProductProcessResult.vue"
import waste from "./assessmentTabWastev1.vue"
import assessmentTabResults from "./assessmentTabResultv1.vue"
import assessmentTabReport from "./assessmentTabReport.vue"
import { useTabsDefinitions } from "@/composables/tabsDefinitions"
import { ApiClient, FeatureFlagClient } from "../../entities/NSwagGenerated"
import lifeCycleSummaryResult from "./lifeCycleSummaryResult.vue"

import { SessionInfo, PageAccess } from "../auth/personSessionData"

import { library } from "@fortawesome/fontawesome-svg-core"
import {
	faInfoCircle,
	faTrash,
	faPen,
	faChartLine,
	faFileLines,
	faFlask,
	faFlaskVial,
	faFlaskPoison,
	faLightbulbOn,
	faSackXmark,
	faSquarePollVertical,
	faCircleNodes,
	faBoxOpenFull,
	faTruckFast,
	faRecycle,
	faFileChartColumn,
} from "@fortawesome/pro-regular-svg-icons"
import { faArrowUpFromGroundWater, faChartPieAlt, faTable } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import AssessmentTabCompare from "./assessmentTabCompare.vue"
library.add(
	faTrash,
	faPen,
	faInfoCircle,
	faChartLine,
	faFileLines,
	faFlask,
	faFlaskVial,
	faFlaskPoison,
	faArrowUpFromGroundWater,
	faLightbulbOn,
	faSackXmark,
	faSquarePollVertical,
	faChartPieAlt,
	faTable,
	faCircleNodes,
	faBoxOpenFull,
	faTruckFast,
	faRecycle,
	faFileChartColumn
)
const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
const featureFlagClient = new FeatureFlagClient(import.meta.env.VITE_API_URL?.toString())

const route = useRoute()
const assessmentId = ref()
const tabsDefinitions = useTabsDefinitions()
const isPackagingReportEnabled = ref(false)

let tabList = [
	"Assessment Details",
	"Synthetic API",
	"Biologics",
	"Product Process",
	"Device & Packaging",
	"Distribution",
	"Consumer End of Life",
	"LifeCycle Summary Result",
]
//let completedTabs = [] as string[]

let tabsAssessmentName = [
	{ tabName: "General Information", tabPage: assessmentTabAssessmentName, enabled: true, icon: "file-lines", isVisible: true },
]
let tabsSmallMolecules = [
	{ tabName: "General Information", tabPage: assessmentTabGeneralInformation, enabled: true, icon: "file-lines", isVisible: true },
	{ tabName: "Raw Materials", tabPage: assessmentTabRawMaterials, enabled: false, icon: "flask", isVisible: true },
	{ tabName: "Utilities", tabPage: assessmentTabUtilities, enabled: false, icon: "lightbulb-on", isVisible: true },
	{ tabName: "Process Waste", tabPage: waste, enabled: false, icon: "sack-xmark", isVisible: true },
	{ tabName: "Result", tabPage: assessmentTabResult, enabled: false, icon: "square-poll-vertical", isVisible: true },
]
let tabsBiologics = [
	{ tabName: "General Information", tabPage: assessmentTabGeneralInformation, enabled: true, icon: "file-lines", isVisible: true },
	{ tabName: "Raw Materials", tabPage: assessmentTabRawMaterials, enabled: false, icon: "flask", isVisible: true },
	{ tabName: "Utilities", tabPage: assessmentTabUtilities, enabled: false, icon: "lightbulb-on", isVisible: true },
	{ tabName: "Process Waste", tabPage: waste, enabled: false, icon: "sack-xmark", isVisible: true },
	{ tabName: "Result", tabPage: assessmentTabBiologicsResult, enabled: false, icon: "square-poll-vertical", isVisible: true },
]
let tabsFormAndFill = [
	{ tabName: "General Information", tabPage: assessmentTabGeneralInformation, enabled: true, icon: "file-lines", isVisible: true },
	{ tabName: "Raw Materials", tabPage: assessmentTabRawMaterials, enabled: false, icon: "flask", isVisible: true },
	{ tabName: "Utilities", tabPage: assessmentTabUtilities, enabled: false, icon: "lightbulb-on", isVisible: true },
	{ tabName: "Process Waste", tabPage: waste, enabled: false, icon: "sack-xmark", isVisible: true },
	{ tabName: "Result", tabPage: assessmentTabProductProcessResult, enabled: false, icon: "square-poll-vertical", isVisible: true },
]
let tabsPackaging = [
	{ tabName: "General Information", tabPage: assessmentTabGeneralInformation, enabled: true, icon: "file-lines", isVisible: true },
	{ tabName: "Device Materials", tabPage: assessmentTabRawMaterials, enabled: false, icon: "flask", isVisible: true },
	{ tabName: "Packaging Materials", tabPage: assessmentTabRawMaterials, enabled: false, icon: "lightbulb-on", isVisible: true },
	{ tabName: "Utilities", tabPage: assessmentTabUtilities, enabled: false, icon: "lightbulb-on", isVisible: true },
	{ tabName: "Result", tabPage: assessmentTabResults, enabled: true, icon: "square-poll-vertical", isVisible: true },
	{ tabName: "Report", tabPage: assessmentTabReport, enabled: true, icon: "file-chart-column", isVisible: true },
	{ tabName: "Compare", tabPage: AssessmentTabCompare, enabled: true, icon: "arrows-spin", isVisible: true },
]
let tabsDistribution = [
	{ tabName: "General Information", tabPage: assessmentTabGeneralInformation, enabled: true, icon: "file-lines", isVisible: true },
	{ tabName: "Downstream Packaging Materials", tabPage: assessmentTabRawMaterials, enabled: false, icon: "flask", isVisible: true },
	{ tabName: "Downstream Distribution", tabPage: assessmentTabDownstreamDistribution, enabled: false, icon: "lightbulb-on", isVisible: true },
	{ tabName: "Packaging End Of Life", tabPage: waste, enabled: false, icon: "file-lines", isVisible: true },
	{ tabName: "Result", tabPage: assessmentTabResults, enabled: false, icon: "square-poll-vertical", isVisible: true },
]
let tabsEndOfLife = [
	//{ tabName: "General Information", tabPage: assessmentTabGeneralInformation, enabled: true, icon: "file-lines", isVisible: true },
	{ tabName: "Process Waste (EoL)", tabPage: waste, enabled: true, icon: "file-lines", isVisible: true },
]
// let tabsLifecycleResult = [
// 	{ tabName: "LifeCycle Summary Result", tabPage: lifeCycleSummaryResult, enabled: true, icon: "square-poll-vertical", isVisible: true },
// ]

//fake

let tabsLifecycleResult = [
	//{ tabName: "General Information", tabPage: assessmentTabGeneralInformation, enabled: true, icon: "file-lines", isVisible: true },
	//{ tabName: "Process Waste (EoL)", tabPage: waste, enabled: true, icon: "file-lines", isVisible: true },
	{ tabName: "LifeCycle Summary Result", tabPage: lifeCycleSummaryResult, enabled: true, icon: "square-poll-vertical", isVisible: true },
]

const tabsMap = {
	tabsAssessmentName,
	tabsSmallMolecules,
	tabsBiologics,
	tabsFormAndFill,
	tabsPackaging,
	tabsDistribution,
	tabsEndOfLife,
	tabsLifecycleResult,
}

class subTab {
	public subTabName: string
}

class tabMap {
	public mainTabName: string
	public subTabs: subTab[]
}

class allTabs {
	public tabs: tabMap[]
}

class tabActualStatus {
	actualMainTabId: string
	actualSubTabName: string
	selectedStepId: string
	generalInformationId: string
}

class allTabsActualStatus {
	public allTabsStatus: tabActualStatus[]
}
class singleTab {
	tabName: string
	tabs: string
	id: string
	activeTab: number
	icon: string
}
const tabs = ref()
const selectedMainTabIndex = ref<number>(0)
const allTabsInformation = ref(new allTabsActualStatus())
onMounted(async () => {
	EventBus.emit("buildBreadcrumb", {
		type: "theassessment",
		label: "",
		id: route.query.assessmentId,
	})
	EventBus.on("checkIfEnableConsumerEndOfLifeTab", () => {
		//checkIfEnableConsumerEndOfLifeTab()
	})
	EventBus.on("moveToEOLTab", () => {
		moveToEOLTab()
	})
	EventBus.on("updateAllTabsInformationPerMainTabEv", (newTabsContents: any) => {
		updateAllTabsInformationPerMainTab(newTabsContents)
	})
	assessmentId.value = route.query.assessmentId

	// Load packaging report feature flag before building tabs
	try {
		const flag = await featureFlagClient.getByName("Packaging Report")
		isPackagingReportEnabled.value = flag.isEnabled || false
	} catch {
		isPackagingReportEnabled.value = false
	}

	// Filter Report tab from packaging if feature flag is disabled
	if (!isPackagingReportEnabled.value) {
		tabsPackaging = tabsPackaging.filter((t) => t.tabName !== "Report")
		tabsMap.tabsPackaging = tabsPackaging
	}

	buildTabPrimary()
})

// watch(selectedMainTabIndex, (newValue) => {
// 	changeTab(newValue)
// })

const moveToEOLTab = () => {
	selectedMainTabIndex.value = tabs.value.findIndex((ele: any) => ele.tabName === tabsDefinitions.consumerEndOfLife.value)

	EventBus.emit("ProcessWasteUpdate" + tabs.value[selectedMainTabIndex.value].id)
}

const updateAllTabsInformation = (newTabsContents: any) => {
	allTabsInformation.value = newTabsContents
}
const updateAllTabsInformationPerMainTab = (newTabsContents: any) => {
	if (tabs.value === undefined) return
	var IndxtoChange = tabs.value.findIndex((tab: any) => tab.id === newTabsContents.id)
	if (IndxtoChange < 0) return
	///tabs.value[IndxtoChange].tabs = newTabsContents.tabs
	tabs.value[IndxtoChange].tabs.splice(0, tabs.value[IndxtoChange].tabs.length, ...newTabsContents.tabs)
}
// function checkIfEnableConsumerEndOfLifeTab() {
// 	var checkIfPackagingScreenIsVisible = tabs.value.findIndex((ele: any) => ele.tabName === tabsDefinitions.packaging.value)
// 	if (checkIfPackagingScreenIsVisible < 0) {
// 		return
// 	} else {
// 		apiClient.checkIfEnableConsumerEndOfLifeTab(assessmentId.value).then((res) => {
// 			tabs.value[tabs.value.findIndex((ele: any) => ele.tabName === tabsDefinitions.consumerEndOfLife.value)].visible = res
// 			//checkWarningForConsumerEndOfLife(!res)
// 		})
// 	}
// }

function buildTabMap(input: any) {
	const allTheTabs = new allTabs()
	allTheTabs.tabs = []
	input.forEach((ele: any) => {
		const tabsMap = new tabMap()
		tabsMap.mainTabName = ele.tabName
		tabsMap.subTabs = []
		ele.tabs.forEach((ele2: any) => {
			tabsMap.subTabs.push({ subTabName: ele2.tabName })
		})
		allTheTabs.tabs.push(tabsMap)
	})
	return allTheTabs
}

function buildTabPrimary() {
	tabs.value = []

	apiClient
		//.screenForClientAllsByTabPosition()
		.subProjectSelectedScreens(assessmentId.value)
		.then((subProjectScreens) => {
			subProjectScreens.forEach((screen: any) => {
				if (SessionInfo.currentUserIsAdmin()) {
					tabs.value.push({
						tabName: screen.screenName,
						tabs: tabsMap[screen.subTabGroupName],
						id: screen.id,
						activeTab: 0,
						icon: screen.icon,
						visible: screen.screenName === "Consumer End of Life" ? false : true,
					})
				} else {
					var matchingScreens = tabList.filter((includedScreenName) => {
						return screen.screenName === includedScreenName
					})

					matchingScreens.forEach((includedScreenName) => {
						if (includedScreenName === screen.screenName) {
							tabs.value.push({
								tabName: screen.screenName,
								tabs: tabsMap[screen.subTabGroupName],
								id: screen.id,
								activeTab: 0,
								icon: screen.icon,
								visible: screen.screenName === "Consumer End of Life" ? false : true,
							})
						}
					})
				}
			})
			return tabs.value
		})
		.then((tt: any) => {
			const allStats = new allTabsActualStatus()
			allStats.allTabsStatus = []
			tt.forEach((el: any) => {
				var tabStatus = new tabActualStatus()
				tabStatus.actualMainTabId = el.id
				tabStatus.actualSubTabName = el.tabs[0].tabName
				allStats.allTabsStatus.push(tabStatus)
			})
			// localStorage.removeItem("actualTabsStatus")
			// localStorage.setItem("actualTabsStatus", JSON.stringify(allStats))
			allTabsInformation.value = allStats
		})
		.then(() => {
			//checkIfEnableConsumerEndOfLifeTab()
			// checkWarningForConsumerEndOfLife()
		})
}
// function buildTabPrimary() {
// 	tabs.value = []

// 	apiClient
// 		//.screenForClientAllsByTabPosition()
// 		.subProjectSelectedScreens(assessmentId.value)
// 		.then((res) => {
// 			res.forEach((single: any) => {
// 				if (SessionInfo.currentUserIsAdmin()) {
// 					tabs.value.push({
// 						tabName: single.screenName,
// 						tabs: tabsMap[single.subTabGroupName],
// 						id: single.id,
// 						activeTab: 0,
// 						icon: single.icon,
// 						visible: single.screenName === "Consumer End of Life" ? false : true,
// 					})
// 				} else {
// 					if (completedTabs.length > 0) {
// 						if (completedTabs.includes(single.screenName))
// 							tabs.value.push({
// 								tabName: single.screenName,
// 								tabs: tabsMap[single.subTabGroupName],
// 								id: single.id,
// 								activeTab: 0,
// 								icon: single.icon,
// 								visible: single.screenName === "Consumer End of Life" ? false : true,
// 							})
// 					} else {
// 						tabs.value.push({
// 							tabName: single.screenName,
// 							tabs: tabsMap[single.subTabGroupName],
// 							id: single.id,
// 							activeTab: 0,
// 							icon: single.icon,
// 							visible: single.screenName === "Consumer End of Life" ? false : true,
// 						})
// 					}
// 				}
// 			})
// 			return tabs.value
// 		})
// 		.then((tt: any) => {
// 			const allStats = new allTabsActualStatus()
// 			allStats.allTabsStatus = []
// 			tt.forEach((el: any) => {
// 				var tabStatus = new tabActualStatus()
// 				tabStatus.actualMainTabId = el.id
// 				tabStatus.actualSubTabName = el.tabs[0].tabName
// 				allStats.allTabsStatus.push(tabStatus)
// 			})
// 			// localStorage.removeItem("actualTabsStatus")
// 			// localStorage.setItem("actualTabsStatus", JSON.stringify(allStats))
// 			allTabsInformation.value = allStats
// 		})
// 		.then(() => {
// 			checkIfEnableConsumerEndOfLifeTab()
// 		})
// }

function changeTab(index: number) {
	let rawMaterialSubTabNames = ["DeviceMaterials", "PackagingMaterials", "DownstreamPackagingMaterials", "RawMaterials"]
	var screenId = tabs.value[index].id
	var screenName = tabs.value[index].tabName
	selectedMainTabIndex.value = index

	// var tabStatus: allTabsActualStatus = JSON.parse(localStorage.getItem("actualTabsStatus")) as allTabsActualStatus
	var getSelectedSubTab = allTabsInformation.value.allTabsStatus
		.find((item: any) => item.actualMainTabId === screenId)
		?.actualSubTabName.replace(/\s+/g, "")

	if (rawMaterialSubTabNames.indexOf(getSelectedSubTab) === -1) {
		EventBus.emit(getSelectedSubTab + "Update" + screenId, {})
	} else {
		EventBus.emit("RawMaterialsUpdate" + route.query.assessmentId, {})
	}
	switch (screenName) {
		case tabsDefinitions.assessmentDetails.value: //Assessment Name Tab
			EventBus.emit("selectedAssessmentNameTab", screenId)
			break
		case tabsDefinitions.syntheticAPI.value: //Syntetic API Tab
			EventBus.emit("selectedAssessmentGeneralInformationTab_" + screenId)
			break
		case tabsDefinitions.biologics.value: //Biologics Tab
			EventBus.emit("selectedAssessmentGeneralInformationTab_" + screenId)
			break
		case tabsDefinitions.productProcess.value: //Form and Fill Tab
			EventBus.emit("selectedAssessmentGeneralInformationTab_" + screenId)
			break
		case tabsDefinitions.packaging.value: //Packaging
			EventBus.emit("selectedAssessmentGeneralInformationTab_" + screenId)
			EventBus.emit("enableDisableDeviceMaterialPackMaterialResults_" + screenId, false)
			// If Result, Compare or Report subtab is selected, trigger validation check (including EOL destination check)
			if (getSelectedSubTab === "Result" || getSelectedSubTab === "Compare" || getSelectedSubTab === "Report") {
				const toUpdate = allTabsInformation.value.allTabsStatus.find((item: any) => item.actualMainTabId === screenId)
				EventBus.emit("validateResult_" + screenId, toUpdate)
			}
			break
		case tabsDefinitions.distribution.value: //Distributioon
			EventBus.emit("selectedAssessmentGeneralInformationTab_" + screenId)
			EventBus.emit("enableDisableDeviceMaterialPackMaterialResults_" + screenId, false)
			break
		case tabsDefinitions.consumerEndOfLife.value: //Consumer End of Life
			EventBus.emit("ProcessWasteUpdate" + screenId)
			break
		case tabsDefinitions.lifecycleSummaryResult.value: //LifeCycle Summary Result
			EventBus.emit("lifeCycleSummaryUpdate" + screenId)
			break
	}
}
</script>
<style scoped>
/* .align-with-tabs {
	vertical-align: middle;
	margin-left: 8px;
}

.tab-icon {
	display: none;
} */
/*
::v-deep(.p-tabview) {
	.p-tabview-nav li .p-tabview-nav-link[aria-selected="true"] {
		background: rgb(139, 35, 35);
		color: rgb(139, 35, 35);
		border-radius: 0.5em 0.5em 0 0;
		border-bottom: rgb(139, 35, 35) solid 2px;
	}
	.p-tabview-nav .p-disabled {
		background: rgb(139, 35, 35);
		color: rgb(139, 35, 35);
		border-radius: 0.5em 0.5em 0 0;
		border-bottom: rgb(139, 35, 35) solid 2px;
		opacity: 1;
	}
	.p-tabview-panels {
		background: white;
		min-height: 100%;
	}
}*/
</style>
